/* eslint-disable react/no-unstable-nested-components */
import parseISO from "date-fns/parseISO";
import Link from "next/link";
import { FormattedMessage, useIntl } from "react-intl";
import { IStripeSubscriptionStatus } from "types/graphqlTypes";
import useSelfie from "../../lib/hooks/useSelfie";

export default function OverdueSubscriptionStickyBanner() {
  const intl = useIntl();
  const user = useSelfie();

  if (!user) {
    return null;
  }

  const { subscription } = user;
  if (!subscription || subscription.status !== IStripeSubscriptionStatus.PastDue || !subscription.latestInvoice) {
    return null;
  }

  const { nextPaymentAttempt } = subscription.latestInvoice;

  return (
    <div className="px-6">
      <div className="m-auto mt-8 max-w-screen-xl">
        <div className="space-y-2 rounded-xl bg-rose-100 p-4 font-aeonik shadow-sm dark:bg-rose-800/20">
          <div>
            <h2 className="text-lg font-bold text-rose-600 dark:text-rose-300">
              <FormattedMessage
                defaultMessage="Fala Investidor!"
                id="hc+0nz"
                description="Banner de assinatura vencida"
              />
            </h2>

            <p className="text-sm font-medium leading-6 tracking-wider text-rose-600 dark:text-rose-400">
              <FormattedMessage
                defaultMessage="...não conseguimos realizar a cobrança da sua assinatura Premium no cartão. Por favor, <link>clique aqui para atualizar os dados do seu cartão.</link>"
                id="j15JJy"
                description="Banner de assinatura vencida"
                values={{
                  link: (text) => (
                    <Link
                      href="/billing/payment-methods"
                      as="/billing/payment-methods"
                      className="text-blue-600 hover:underline dark:text-blue-400"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {text}
                    </Link>
                  ),
                }}
              />
            </p>
          </div>

          {nextPaymentAttempt && (
            <p className="text-md font-medium leading-6 tracking-wide text-rose-800">
              <FormattedMessage
                defaultMessage="A próxima tentativa de cobrança será em <strong>{nextPaymentAttempt}</strong>. Regularize seu pagamento o quanto antes para continuar garantindo o seu acesso. Caso falte com o pagamento, seu acesso será cortado."
                id="Ythha6"
                description="Banner de assinatura vencida"
                values={{
                  strong: (text) => (
                    <strong className="rounded-md bg-brand p-1 text-xs font-extrabold text-white">{text}</strong>
                  ),
                  nextPaymentAttempt: intl.formatDate(parseISO(nextPaymentAttempt), {
                    day: "numeric",
                    month: "numeric",
                  }),
                }}
              />
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
